<app-template-page [forPrint]="false"> </app-template-page>
